import React from 'react';
import './TableLevelHeader.css';

export const TableLevelHeader = ({
    levelData,
    extraClass = '',
}) => {
    const headerBaseClass = 'loyalty-table-level-header';
    const headerClass = [
        headerBaseClass,
        extraClass,
    ].join(' ');
    const headerStyles = {
        '--cell-bg-color': levelData.colors.main,
    };

    return <div className={headerClass} style={headerStyles} >
        <img className={`${headerBaseClass}__icon`} src={levelData.images.level} alt=""/>
        <span className={`${headerBaseClass}__title`}>{levelData.description}</span>
        <img className={`${headerBaseClass}__progress`} src={levelData.images.progress} alt=""/>
    </div>;
};
